import React, { useContext } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Container } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import BusinessListPage from "./pages/business/BusinessListPage";
import ViewCatalogPage from "./pages/catalog/ViewCatalogPage";
import EditCatalogPage from "./pages/catalog/EditCatalogPage";
import Analytics from "./Analytics";
import LandingPage from "./LandingPage";
import AuthPage from "./AuthPage";
import AuthProvider from "./AuthContext";
import ProtectedLayout from "./ProtectedLayout";
import CreateUser from "./CreateUser";
import ApprovePayment from "./ApproveBusiness";
// import ApprovePayment from "./Test";
import DeactivateBusiness from "./DeactivateBusiness";
// import DeactivateBusiness from "./Test";
import { UserRoleContext } from "./GetUserRole";
import Test from "./Test";
import UploadRecord from "./features/upload/UploadRecord";
import ChangePlan from "./ChangePlan";
import BusinessList from "./BusinessList";
import BusinessDetails from "./BusinessDetails";
import ClientLanding from "./ClientLanding";
import ResetPasswordPage from "./ResetPasswordPage";
import DesignerCanvas from "./features/designer/DesignerCanvas";
import DesignerTemplatesPanel from "./features/designer/DesignerTemplatesPanel";
import SubscriptionPage from "./pages/billing/SubscriptionPage";
import MyReferralsPage from "./pages/referrals/MyReferralsPage";
import DesignerPreviewPanel from "./features/designer/DesignerPreviewPanel";
import NotFound from "./NotFound";
import VerifyProductPage from "./features/authentication/pages/VerifyProductPage";
import BusinessServicesPage from "./pages/business/BusinessesHomePage";
import ProductAuthenticationPage from "./ProductAuthenticationPage";
import CampaignQrPage from "./features/qr/pages/CampaignQrPage";
import MuseumsGalleriesPage from "./MuseumsGalleriesPage";
import SurveysFeedbackPage from "./SurveysFeedbackPage";
import BorderRadiusCap from "./BorderRadiusCap";
import SurveyPublicPage from "./SurveyPublicPage";

const appTheme = createTheme({
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: "10px",
          paddingRight: "10px",
          "@media (min-width:600px)": {
            paddingLeft: "14px",
            paddingRight: "14px",
          },
        },
        maxWidthXs: {
          maxWidth: "720px !important",
        },
        maxWidthSm: {
          maxWidth: "960px !important",
        },
        maxWidthMd: {
          maxWidth: "1240px !important",
        },
        maxWidthLg: {
          maxWidth: "1520px !important",
        },
        maxWidthXl: {
          maxWidth: "1680px !important",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          minHeight: 56,
          borderRadius: 8,
        },
        input: {
          boxSizing: "border-box",
          minHeight: "56px",
          padding: "0 14px",
          display: "flex",
          alignItems: "center",
        },
      },
    },
  },
});

function App() {

  const { role, loading } = useContext(UserRoleContext);
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    // <Router baseame="/qr">
    <>
      <BorderRadiusCap />
      <ThemeProvider theme={appTheme}>
        <Router>
          {/*-- <div> */}
          <AuthProvider>
            {/* <UserProvider> */}
            <Container maxWidth={false} disableGutters className="site-shell" sx={{ width: "100%" }}>
              {/*-- <Router> */}
              <Routes>

                <Route exact path="/" element={<LandingPage />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/r/:code" element={<AuthPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/client/:id" element={<ClientLanding />} />
                <Route path="/survey/:id" element={<SurveyPublicPage />} />
                <Route path="/design" element={<DesignerCanvas />} />
                <Route path="/design2" element={<DesignerTemplatesPanel />} />
                <Route path="/verify" element={<VerifyProductPage />} />
                <Route path="/restaurant" element={<BusinessServicesPage />} />
                <Route path="/products" element={<ProductAuthenticationPage />} />
                <Route path="/campaign" element={<CampaignQrPage />} />
                <Route path="/museums" element={<MuseumsGalleriesPage />} />
                <Route path="/surveys" element={<SurveysFeedbackPage />} />


                <Route path="/aaro" element={<SubscriptionPage />} />
                <Route path="*" element={<NotFound />} />

                <Route element={<ProtectedLayout />}>
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/list" element={<BusinessListPage />} />
                  {/* <Route path="/view-qr/:id" element={<ViewQR />} /> */}
                  <Route path="/view-menu/:id" element={<ViewCatalogPage />} />
                  <Route path="/test" element={<Test />} />

                  <Route path="referral" element={<MyReferralsPage />} />
                  {/* <Route path="/view-qr/:id" element={<QRCodeGenerator3 />} /> */}
                  <Route path="/view-qr/:id" element={<DesignerPreviewPanel />} />

                  {(role === 1) && (
                    <>
                      <Route path="/approve" element={<ApprovePayment />} />
                      <Route path="/deactivate" element={<DeactivateBusiness />} />
                      <Route path="/businesses" element={<BusinessList />} />
                      <Route path="/business/:id" element={<BusinessDetails />} />
                    </>
                  )}

                  {(role === 3 || role === 2 || role === 1) && (
                    <>
                      <Route path="/change-plan" element={<ChangePlan />} />
                      <Route path="/create-user" element={<CreateUser />} />
                      <Route path="/upload" element={<UploadRecord />} />
                      <Route path="/edit-menu/:id/:category" element={<EditCatalogPage />} />
                    </>
                  )}
                </Route>
              </Routes>
              {/* </Router> */}
            </Container>
            {/* </UserProvider> */}
          </AuthProvider>
          {/* </div> */}

        </Router>
      </ThemeProvider>

    </>
  );
}

export default App;
